module.exports = __webpack_public_path__ + "img/menu3-it.9e2aaa01.jpg";